import React, { lazy, Suspense, useEffect } from "react";
import Slider from "../../components/shared/Slider";
import PageSEO from "../../components/shared/PageSEO";
import AboutUsSection from "./components/AboutUsSection";
import "./Home.scss";
import "aos/dist/aos.css";

const Quote            = lazy(() => import("./components/Quote"));
const NewsSection      = lazy(() => import("./components/NewsSection"));
const ServicesSection  = lazy(() => import("./components/ServicesSection"));
const Vision2030Section = lazy(() => import("./components/Vision2030Section"));
const separator = "assets2/imges/separator.svg";
const hajPattern = "/assets2/imges/haj-pattern.svg";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageSEO
        title="الرئيسية"
        description="أمانة العاصمة المقدسة — نسعى في تقديم خدمات بلدية راقية لساكني أم القرى وقاصديها. تصفح الخدمات الإلكترونية، الأخبار، والمشاريع."
      />
      <Slider />
      <div className="">
        <AboutUsSection />
        <Suspense fallback={null}>
          <Quote />
        </Suspense>
        {/* <img src={hajPattern} alt="" aria-hidden="true" className="w-full" loading="lazy" decoding="async" width="1280" height="21" style={{ aspectRatio: '1280/21' }} /> */}
        <Suspense fallback={null}>
          <NewsSection />
        </Suspense>
        <Suspense fallback={null}>
          <ServicesSection />
        </Suspense>
        <Suspense fallback={null}>
          <Vision2030Section />
        </Suspense>
      </div>
    </>
  );
}

export default Home;
